import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './MarcheTravail.css';
import { 
  FaBriefcase,
  FaSearch,
  FaFileAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaRegClock,
  FaEuroSign,
  FaCalendarAlt,
  FaArrowLeft,
  FaCheckCircle,
  FaChartLine,
  FaUsers,
  FaLaptopCode,
  FaHandshake,
  FaGraduationCap,
  FaBuilding,
  FaStar,
  FaLinkedin,
  FaRegFileAlt,
  FaChartBar,
  FaLightbulb
} from 'react-icons/fa';

const MarcheTravail = () => {
  const navigate = useNavigate();

  const jobSectors = [
    {
      icon: <FaLaptopCode />,
      name: "Tech & Digital",
      opportunities: "Développeur, Data Analyst, UX/UI Designer",
      avgSalary: "25-35€/h",
      demand: "Très élevée",
      color: "#ff6b6b"
    },
    {
      icon: <FaHandshake />,
      name: "Commerce & Vente",
      opportunities: "Conseiller client, Vendeur, Commercial",
      avgSalary: "11.65-15€/h",
      demand: "Élevée",
      color: "#4ecdc4"
    },
    {
      icon: <FaBuilding />,
      name: "Hôtellerie & Restauration",
      opportunities: "Serveur, Réceptionniste, Chef de rang",
      avgSalary: "11.65-14€/h",
      demand: "Très élevée",
      color: "#ffd93d"
    },
    {
      icon: <FaUsers />,
      name: "Services à la personne",
      opportunities: "Baby-sitting, Soutien scolaire, Aide à domicile",
      avgSalary: "10-20€/h",
      demand: "Élevée",
      color: "#6c5ce7"
    },
    {
      icon: <FaChartLine />,
      name: "Marketing & Communication",
      opportunities: "Community Manager, Assistant marketing, Rédacteur web",
      avgSalary: "12-18€/h",
      demand: "Moyenne",
      color: "#a8e6cf"
    },
    {
      icon: <FaGraduationCap />,
      name: "Enseignement & Formation",
      opportunities: "Cours particuliers, Assistant de langue, Tutorat",
      avgSalary: "15-25€/h",
      demand: "Élevée",
      color: "#ff8b94"
    }
  ];

  const jobSearchPlatforms = [
    {
      name: "LinkedIn",
      icon: <FaLinkedin />,
      url: "https://www.linkedin.com",
      description: "Réseautage professionnel et offres d'emploi",
      color: "#0077b5"
    },
    {
      name: "Indeed",
      icon: <FaSearch />,
      url: "https://www.indeed.fr",
      description: "Agrégateur d'offres d'emploi",
      color: "#fcaf17"
    },
    {
      name: "Welcome to the Jungle",
      icon: <FaBriefcase />,
      url: "https://www.welcometothejungle.com",
      description: "Offres en startup et entreprise innovante",
      color: "#ff7e5e"
    },
    {
      name: "Jobaviz",
      icon: <FaChartBar />,
      url: "https://www.jobaviz.fr",
      description: "Spécialisé dans les jobs étudiants",
      color: "#4caf50"
    },
    {
      name: "Pôle Emploi",
      icon: <FaBuilding />,
      url: "https://www.pole-emploi.fr",
      description: "Offices publics de l'emploi",
      color: "#0055a5"
    },
    {
      name: "Studyrama Emploi",
      icon: <FaGraduationCap />,
      url: "https://www.studyrama-emploi.com",
      description: "Jobs et stages pour étudiants",
      color: "#e74c3c"
    }
  ];

  const tips = [
    {
      icon: <FaFileAlt />,
      title: "CV sur mesure",
      description: "Adaptez votre CV à chaque offre. Mettez en avant vos compétences linguistiques et votre adaptabilité."
    },
    {
      icon: <FaSearch />,
      title: "Candidature spontanée",
      description: "N'hésitez pas à postuler même sans offre. Les entreprises apprécient la motivation."
    },
    {
      icon: <FaRegClock />,
      title: "Gestion du temps",
      description: "Respectez la limite légale : 964 heures par an (60% du temps plein)."
    },
    {
      icon: <FaEuroSign />,
      title: "Connaître ses droits",
      description: "Salaire minimum : 11.88€ brut/h en 2024. Vérifiez votre convention collective."
    },
    {
      icon: <FaUsers />,
      title: "Réseautage",
      description: "Participez aux forums étudiants, rejoignez des groupes LinkedIn, allez aux afterworks."
    },
    {
      icon: <FaHandshake />,
      title: "Contrat de travail",
      description: "Exigez toujours un contrat écrit (CDI, CDD, contrat d'apprentissage ou stage)."
    }
  ];

  const studentJobs = [
    {
      title: "Baby-sitting",
      hourlyRate: "10-15€/h",
      platforms: "Yoopies, Nounou-top, garde-enfant.fr",
      requirements: "Expérience enfants, parfois diplôme BAFA",
      flexibility: "Horaires flexibles"
    },
    {
      title: "Soutien scolaire",
      hourlyRate: "15-25€/h",
      platforms: "Acadomia, Complétude, Superprof",
      requirements: "Bonne maîtrise de la matière, pédagogie",
      flexibility: "En soirée ou week-end"
    },
    {
      title: "Serveur en restauration",
      hourlyRate: "11.65-14€/h + pourboires",
      platforms: "Indeed, candidature spontanée",
      requirements: "Dynamisme, anglais souvent requis",
      flexibility: "Soirées et week-ends"
    },
    {
      title: "Vendeur en magasin",
      hourlyRate: "11.65-13€/h",
      platforms: "Indeed, emploi-store",
      requirements: "Relation client, disponibilité",
      flexibility: "Samedis et périodes de soldes"
    },
    {
      title: "Community Manager",
      hourlyRate: "12-18€/h",
      platforms: "Malt, Freelance, LinkedIn",
      requirements: "Maîtrise des réseaux sociaux, créativité",
      flexibility: "Télétravail possible"
    },
    {
      title: "Livraison",
      hourlyRate: "10-15€/h + pourboires",
      platforms: "Uber Eats, Deliveroo",
      requirements: "Vélo/scooter, smartphone",
      flexibility: "Horaires libres"
    }
  ];

  const administrativeSteps = [
    {
      step: "1. Vérifier son droit au travail",
      details: "Les étudiants étrangers peuvent travailler 964h/an avec un titre de séjour étudiant valide"
    },
    {
      step: "2. Obtenir un numéro de sécurité sociale",
      details: "Indispensable pour être payé légalement et cotiser"
    },
    {
      step: "3. Signer un contrat de travail",
      details: "CDI, CDD, contrat d'apprentissage ou stage. Exigez un écrit !"
    },
    {
      step: "4. Déclarer ses revenus",
      details: "À partir d'avril chaque année, déclarez vos revenus même si exonérés"
    }
  ];

  const interviewTips = [
    "Préparez une présentation de 2 minutes sur vous-même",
    "Mettez en avant vos compétences linguistiques (atout majeur)",
    "Préparez des exemples concrets de vos expériences",
    "Habillez-vous de manière professionnelle",
    "Préparez des questions pour l'employeur",
    "Arrivez 10 minutes en avance",
    "Souriez et soyez positif"
  ];

  const successStories = [
    {
      name: "Maria, Brésil",
      job: "Développeuse Web en alternance",
      quote: "Grâce au contrat d'apprentissage, je finance mes études et acquiers une expérience précieuse."
    },
    {
      name: "Ahmed, Maroc",
      job: "Conseiller client bilingue",
      quote: "Mon bilinguisme français-anglais m'a ouvert beaucoup de portes dans le service client."
    },
    {
      name: "Li, Chine",
      job: "Baby-sitter",
      quote: "Le baby-sitting m'a permis d'améliorer mon français tout en ayant des horaires flexibles."
    }
  ];

  return (
    <div className="mt-page">
      {/* Hero Section */}
      <div className="mt-hero mt-hero--work">
        <div className="mt-hero__background"></div>
        <div className="mt-hero__content">
          <button className="mt-back-button" onClick={() => navigate('/association')}>
            <FaArrowLeft /> Retour aux services
          </button>
          <div className="mt-hero__icon">
            <FaBriefcase />
          </div>
          <h1 className="mt-hero__title">Marché du Travail en France</h1>
          <p className="mt-hero__subtitle">Conseils et accompagnement pour trouver un emploi étudiant en France</p>
        </div>
      </div>

      <div className="mt-content">
        <div className="mt-container">
          {/* Introduction */}
          <div className="mt-intro">
            <h2 className="mt-section-title">Trouvez votre job étudiant</h2>
            <p className="mt-intro__text">
              Travailler pendant vos études en France est une excellente opportunité pour financer votre formation, 
              acquérir de l'expérience professionnelle et améliorer votre français. Découvrez les secteurs qui recrutent, 
              les plateformes de recherche d'emploi, et tous nos conseils pour réussir votre insertion professionnelle 
              tout en respectant votre statut d'étudiant étranger.
            </p>
            <div className="mt-legal-info">
              <FaRegClock className="mt-legal-info__icon" />
              <span>Limite légale : 964 heures par an (60% du temps plein)</span>
            </div>
          </div>

          {/* Secteurs qui recrutent */}
          <div className="mt-section">
            <h2 className="mt-section-title">Secteurs qui recrutent</h2>
            <div className="mt-grid mt-grid--sectors">
              {jobSectors.map((sector, index) => (
                <div className="mt-card mt-card--sector" key={index} style={{ borderTopColor: sector.color }}>
                  <div className="mt-card__icon" style={{ color: sector.color }}>
                    {sector.icon}
                  </div>
                  <h3 className="mt-card__title">{sector.name}</h3>
                  <p className="mt-card__opportunities">{sector.opportunities}</p>
                  <div className="mt-card__info">
                    <div className="mt-info-item">
                      <FaEuroSign className="mt-info-item__icon" />
                      <span>{sector.avgSalary}</span>
                    </div>
                    <div className="mt-info-item">
                      <FaChartLine className="mt-info-item__icon" />
                      <span>{sector.demand}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Plateformes de recherche */}
          <div className="mt-section">
            <h2 className="mt-section-title">Plateformes de recherche d'emploi</h2>
            <div className="mt-grid mt-grid--platforms">
              {jobSearchPlatforms.map((platform, index) => (
                <a 
                  href={platform.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-platform-card"
                  key={index}
                  style={{ borderBottomColor: platform.color }}
                >
                  <div className="mt-platform-card__icon" style={{ color: platform.color }}>
                    {platform.icon}
                  </div>
                  <div className="mt-platform-card__info">
                    <h3 className="mt-platform-card__name">{platform.name}</h3>
                    <p className="mt-platform-card__desc">{platform.description}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* Jobs étudiants populaires */}
          <div className="mt-section">
            <h2 className="mt-section-title">Jobs étudiants populaires</h2>
            <div className="mt-grid mt-grid--jobs">
              {studentJobs.map((job, index) => (
                <div className="mt-card mt-card--job" key={index}>
                  <h3 className="mt-card__title">{job.title}</h3>
                  <div className="mt-card__rate">
                    <FaEuroSign className="mt-card__rate-icon" />
                    <span>{job.hourlyRate}</span>
                  </div>
                  <div className="mt-card__detail">
                    <FaSearch className="mt-card__detail-icon" />
                    <span>{job.platforms}</span>
                  </div>
                  <div className="mt-card__detail">
                    <FaCheckCircle className="mt-card__detail-icon" />
                    <span>{job.requirements}</span>
                  </div>
                  <div className="mt-card__detail">
                    <FaRegClock className="mt-card__detail-icon" />
                    <span>{job.flexibility}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Conseils pratiques */}
          <div className="mt-section">
            <h2 className="mt-section-title">Conseils pour réussir</h2>
            <div className="mt-grid mt-grid--tips">
              {tips.map((tip, index) => (
                <div className="mt-card mt-card--tip" key={index}>
                  <div className="mt-card__tip-icon">{tip.icon}</div>
                  <h3 className="mt-card__title">{tip.title}</h3>
                  <p className="mt-card__description">{tip.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Démarches administratives */}
          <div className="mt-section">
            <h2 className="mt-section-title">Démarches administratives</h2>
            <div className="mt-steps-list">
              {administrativeSteps.map((step, index) => (
                <div className="mt-step" key={index}>
                  <div className="mt-step__number">{step.step.split('.')[0]}</div>
                  <div className="mt-step__content">
                    <h3 className="mt-step__title">{step.step}</h3>
                    <p className="mt-step__text">{step.details}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Conseils entretien */}
          <div className="mt-section">
            <h2 className="mt-section-title">Préparez votre entretien</h2>
            <div className="mt-interview-tips">
              {interviewTips.map((tip, index) => (
                <div className="mt-interview-tip" key={index}>
                  <FaStar className="mt-interview-tip__icon" />
                  <span>{tip}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Success Stories */}
          <div className="mt-section">
            <h2 className="mt-section-title">Ils ont réussi</h2>
            <div className="mt-grid mt-grid--stories">
              {successStories.map((story, index) => (
                <div className="mt-card mt-card--story" key={index}>
                  <div className="mt-card__quote">"</div>
                  <p className="mt-card__story-text">{story.quote}</p>
                  <div className="mt-card__author">
                    <strong>{story.name}</strong>
                    <span>{story.job}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Section */}
          <div className="mt-contact">
            <h2 className="mt-section-title mt-section-title--centered">Besoin d'aide dans votre recherche ?</h2>
            <p className="mt-contact__text">Nous vous accompagnons dans votre insertion professionnelle</p>
            <div className="mt-contact-buttons">
              <Link to="/contact" className="mt-button mt-button--primary">
                <FaEnvelope /> Aide CV et lettre de motivation
              </Link>
              <Link to="/rendez-vous" className="mt-button mt-button--secondary">
                <FaPhoneAlt /> Conseil personnalisé
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarcheTravail;